import { api } from "./configs/axiosConfigs"

export const PriceListAPI = {
    
    getPriceList: async (data:any) => {
        const response = await api.get(
            '/pricelist', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getPriceListByCompany: async (data:any) => {
        const response = await api.get(
            '/pricelist/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createPriceList: async (data: any) => {
        const response = await api.post(
            '/pricelist/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    addProducts: async (data: any) => {
        const response = await api.post(
            '/pricelist/addProducts', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editPriceList: async (idlist: number, data: any) => {
        const response = await api.patch(
            `/pricelist/${idlist}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    duplicatePriceList: async (data: any) => {
        const response = await api.post(
            '/pricelist/duplicate', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    deletePriceList: async (idlist: number) => {
        const response = await api.delete(
            `/pricelist/${idlist}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}